<template>
  <!--begin::OffersSpecial index-->
  <div class="gray-box">
    <div
      class="white-box shadow-box p-12"
      title="Pendiente de definir"
      style="height: 50vh"
    >
      TBD...
    </div>
  </div>
  <!--end::OffersSpecial index-->
</template>

<script>
export default {
  name: "OffersSpecialIndex"
};
</script>
